// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type InvoiceGenerateProgressiveQueryVariables = Types.Exact<{
  invoiceGenerateProgressiveRequestDTO: Types.InvoiceGenerateProgressiveRequestDtoInput;
}>;


export type InvoiceGenerateProgressiveQueryResult = { __typename?: 'Query', invoiceGenerateProgressive: number | null };

export const InvoiceGenerateProgressiveGql = gql`
    query InvoiceGenerateProgressive($invoiceGenerateProgressiveRequestDTO: InvoiceGenerateProgressiveRequestDTOInput!) {
  invoiceGenerateProgressive(
    invoiceGenerateProgressiveRequestDTO: $invoiceGenerateProgressiveRequestDTO
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceGenerateProgressiveInjectable extends Apollo.Query<InvoiceGenerateProgressiveQueryResult, InvoiceGenerateProgressiveQueryVariables> {
    override document = InvoiceGenerateProgressiveGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */